import { render, staticRenderFns } from "./covid.vue?vue&type=template&id=33456b9c"
import script from "./covid.vue?vue&type=script&lang=js"
export * from "./covid.vue?vue&type=script&lang=js"
import style0 from "./covid.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/covid/covid.vue
// module id = bs+D
// module chunks = 0